import { TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Setting } from "../../types/Settings";
import { useLoadingStore } from "../../store/loadingStore";
import { executeFetch, executePut } from "../../helper/Api";
import useToastStore from "../../store/toastStore";


export default function SettingsConfig () {
    //States
   const [settings,setSettings] = useState<Setting[]>([]);
    const {setLoading} = useLoadingStore();
    const {showToast} = useToastStore();


    //Action
    const handleChangeSettings = (id: string, value: string) => {
        setSettings(prevSettings => 
            prevSettings.map(setting => 
                setting.id === id ? { ...setting, value } : setting
            )
        );
    };
    const saveSettings = async () => {
        setLoading(true);
        const resp = await executePut<Setting[],Setting[]>('Settings/UpdateSettings',settings,{admin:true});
        if(resp.error){
          showToast('Something went wrong updating settings!','error')
          console.error(resp.error.message);
        }else{
          showToast('Successfully updated settings!','success')
          setSettings(resp.data);
        }
        setLoading(false);    
    }

    //Effects
   useEffect(()=>{
    const fetchSettings = async () => {
        setLoading(true);
        //fetch home sliders
        const resp = await executeFetch<Setting[]>('Settings/GetSettings',{admin:true});
        if(resp.error){
           console.error(resp.error.message)
        }else{
         setSettings(resp.data)
        }
        setLoading(false);
    } 
    fetchSettings();
   },[])
   useEffect(()=>{
    console.log('Current settings:', settings);
    console.log('Image path:', settings.find(x => x.name === 'Product Image Path'));
   },[settings])

    //settings
    const imagePath = settings?.find(x => x.name === 'Product Image Path'); 


    return (
      <div className="admin-page">
        <h1 className="admin-page-title">Settings</h1>
        <div className="admin-section settings-general">

            {imagePath && (
                <div className="setting">
                        <TextField
                            className="settingsText"
                            label={imagePath.name}
                            
                            value={imagePath.value || ''}
                            onChange={(e) => handleChangeSettings(imagePath.id, e.target.value)}
                        />
                </div>
            )}
           
        </div>
        <div className="floatingAdminActionBar">
            <button className="adminSave" onClick={saveSettings}>Save</button>
        </div>
      </div>
    );
  };
  
  